import { render } from "./News.vue?vue&type=template&id=6ece7dfb"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/AdvancedSearch/News.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ece7dfb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ece7dfb', __exports__)) {
    api.reload('6ece7dfb', __exports__)
  }
  
  module.hot.accept("./News.vue?vue&type=template&id=6ece7dfb", () => {
    api.rerender('6ece7dfb', render)
  })

}


export default __exports__